export const getStatusText = (typeId, DEVICE_TYPE) => {
  if (typeId === DEVICE_TYPE.Ready) return "Ready";
  if (typeId === DEVICE_TYPE.Out_for_Delivery) return "Out for Delivery";
  if (typeId === DEVICE_TYPE.Arrived) return "Arrived";
  if (typeId === DEVICE_TYPE.Stocked) return "Stocked";
  if (typeId === DEVICE_TYPE.Return) return "Return";
  if (typeId === DEVICE_TYPE.Cancelled) return "Cancelled";
  if (typeId === DEVICE_TYPE.Completed) return "Completed";
  if (typeId === DEVICE_TYPE.Hold) return "On Hold";
  return "";
};

export const compareOrders = (a = {}, b = {}, DEVICE_TYPE) => {
  // Helper function to get order priority
  // Lower number = higher priority (appears first)
  const getOrderPriority = (order) => {
    const isArrived = order && order.type_id === DEVICE_TYPE.Arrived;
    const isPaid = order && (order.is_paid === true || order.is_payroll_deduct === true);
    
    if (isArrived && isPaid) {
      return 1; // Highest priority: Arrived + Paid/PayLater
    }
    if (isArrived) {
      return 2; // Second priority: Arrived (not paid)
    }
    if (isPaid) {
      return 3; // Third priority: Paid/PayLater (not arrived)
    }
    return 4; // Lowest priority: Other orders
  };

  const priorityA = getOrderPriority(a);
  const priorityB = getOrderPriority(b);

  // Compare by priority first
  if (priorityA !== priorityB) {
    return priorityA - priorityB; // Lower priority number comes first
  }

  // If same priority, maintain original order (stable sort)
  return 0;
};

export const calculateTotalDueAmount = (popupData) => {
  if (
    !popupData ||
    !popupData.items ||
    !Array.isArray(popupData.items) ||
    popupData.items.length === 0
  ) {
    return 0;
  }

  return popupData.items.reduce((sum, current) => {
    const price = parseFloat(current.price);
    if (!isNaN(price)) {
      return sum + price;
    }
    return sum;
  }, 0);
};

export const formatCurrency = (amount = 0) => {
  const numericAmount = Number.isFinite(amount) ? amount : 0;
  return `$${numericAmount.toFixed(2)}`;
};





// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/helpers/orderUtils.js